// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound__notFound___NkEAj","resultsTitle":"NotFound__resultsTitle___AFCNc"};